import { createSlice } from '@reduxjs/toolkit';
import OrganizationService from '../services/OrganizationService';
import errorHandle from './errorHandle';

// 可以放組織相關內容
export const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    integration: null,
    ga4EventDomain: null,
    enabledEC: null,
    // 組織成員指派用
    membersList: [],
    // 標籤列表
    tagCandidates: [],
    // 確認組織購買功能 quota, used
    resources: {},
  },
  reducers: {
    setOrgnaization: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    setTagCandidates: (state, action) => ({
      ...state,
      tagCandidates: action.payload,
    }),
  },
});

export const { setOrgnaization, setTagCandidates } = organizationSlice.actions;

export const getOrganization = orgId => async dispatch => {
  try {
    const data = await OrganizationService.getOrganization(orgId);
    if (data) {
      dispatch(
        setOrgnaization({
          ...data,
        }),
      );
    }
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const saveDefaultTemplate =
  (orgId, templateId, templateType, name, elements, expiredAt) =>
  async dispatch => {
    try {
      await OrganizationService.saveDefaultTemplate(
        orgId,
        templateId,
        templateType,
        name,
        elements,
        expiredAt,
      );
    } catch (error) {
      dispatch(errorHandle(error));
    }
  };

export const getService = (orgId, provider) => async dispatch => {
  try {
    const data = await OrganizationService.getService(orgId, provider);
    if (data) {
      dispatch(
        setOrgnaization({
          serviceFeatures: data,
        }),
      );
    }
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getIntegration = orgId => async dispatch => {
  try {
    const data = await OrganizationService.getIntegration(orgId);
    if (data) {
      dispatch(
        setOrgnaization({
          integration: data,
        }),
      );
    }
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getGA4EventSetting = orgId => async dispatch => {
  try {
    const [ga4EventDomain, enabledEC] = await Promise.all([
      OrganizationService.getGA4EventDomain(orgId),
      OrganizationService.getEnableEC(orgId),
    ]);

    dispatch(
      setOrgnaization({
        ga4EventDomain,
        enabledEC,
      }),
    );
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getOrganizationMembers = options => async (dispatch, getState) => {
  try {
    const { organization } = getState();

    const result = await OrganizationService.getOrganizationMembers({
      org: organization,
      ...options,
    });

    dispatch(setOrgnaization({ membersList: result }));
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const findTag = (tagName, orgId) => async dispatch => {
  try {
    dispatch(setTagCandidates([]));
    const result = await OrganizationService.findTagV3(tagName, orgId);
    const tags = result.data.map(tag => ({
      id: tag._id,
      name: tag._id,
    }));
    dispatch(setTagCandidates(tags));
  } catch (error) {
    dispatch(setTagCandidates([]));
    dispatch(errorHandle(error));
  }
};

export const getNextResource = orgId => async dispatch => {
  try {
    const data = await OrganizationService.getNextResource(
      orgId,
      'number8_next',
    );
    if (data?.resources) {
      dispatch(
        setOrgnaization({
          resources: data?.resources,
        }),
      );
    }
  } catch (error) {
    errorHandle(error);
  }
};

export const checkResourceLimit = resourceName => (dispatch, getState) => {
  try {
    const { resources } = getState().organization;
    const { quota, used } = resources?.[resourceName] || {};
    const result = !(used >= quota && resources !== undefined);

    return result;
  } catch (error) {
    return false;
  }
};

export default organizationSlice.reducer;
